import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import PageTransition from './components/PageTransition'
import WhatsAppButton from './components/WhatsAppButton'
import HomePage from './pages/HomePage'
import GaleriaPage from './pages/GaleriaPage'
import SobrePage from './pages/SobrePage'
import Contact from './pages/Contact'
import Services from './pages/Services'
import { cn } from './lib/utils'
import './index.css'

// Volta ao topo ao trocar de página (exceto quando há uma âncora, ex.: /galeria#casal)
function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0)
  }, [pathname, hash])
  return null
}

function Layout() {
  const { pathname } = useLocation()
  // Na Home o hero fica por trás do cabeçalho; nas outras páginas o conteúdo começa abaixo dele.
  const isHome = pathname === '/'

  return (
    <div className="flex min-h-screen flex-col">
      <PageTransition />
      <Header />
      <main className={cn('flex-1', !isHome && 'pt-16')}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/galeria" element={<GaleriaPage />} />
          <Route path="/sobre" element={<SobrePage />} />
          <Route path="/contato" element={<Contact />} />
          <Route path="/servicos" element={<Services />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  )
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout />
    </Router>
  )
}

export default App
